/**
 * ChatSelectionBar — TG-style top-bar для multi-select режима в чате.
 *
 * Извлечён из ChatPage.tsx (P2#10c). Подменяет обычную шапку чата пока
 * активен `selectionMode`. Параллельный набор кнопок:
 *   FORWARD N | DELETE N | (RESTORE N если есть deleted) | spacer | CANCEL
 *
 * Stateless — родитель управляет selectedIds/selectedAttachmentIds/режимом.
 */

export type ChatSelectionBarProps = {
  totalSelectedCount: number;
  selectedIdsSize: number;
  selectedDeletedIds: number[];
  onForward: () => void;
  onDelete: () => void;
  onRestore: () => void;
  onCancel: () => void;
};

export function ChatSelectionBar({
  totalSelectedCount, selectedIdsSize, selectedDeletedIds,
  onForward, onDelete, onRestore, onCancel,
}: ChatSelectionBarProps) {
  return (
    <div className="chat-selection-bar">
      <button
        type="button"
        className="chat-selection-btn"
        disabled={totalSelectedCount === 0}
        onClick={onForward}
      >
        Переслать <span className="chat-selection-count">{totalSelectedCount}</span>
      </button>
      <button
        type="button"
        className="chat-selection-btn is-danger"
        disabled={selectedIdsSize === 0}
        onClick={onDelete}
      >
        Удалить <span className="chat-selection-count">{selectedIdsSize}</span>
      </button>
      {selectedDeletedIds.length > 0 && (
        <button
          type="button"
          className="chat-selection-btn"
          onClick={onRestore}
        >
          Восстановить <span className="chat-selection-count">{selectedDeletedIds.length}</span>
        </button>
      )}
      <div style={{ flex: 1 }} />
      <button type="button" className="chat-selection-btn" onClick={onCancel}>
        Отмена
      </button>
    </div>
  );
}
